import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGauge,
  faMoon,
  faPerson,
  faRocket,
  faTableList,
  faUsers,
  faGears,
  faBell,
  faUserGroup,
  faBuildingColumns,
  faWallet,
  faFileInvoice,
  faReceipt,
  faPlaneCircleCheck,
  faUsersBetweenLines,
  faUsersGear,
  faUserClock,
  faUserPen,
  faMoneyBillTrendUp,
  faFileCirclePlus,
  faClipboardList,
  faSheetPlastic,
  faMoneyBillWave,
  faTable,
  faPiggyBank,
  faBarsStaggered,
  faMoneyBillTransfer,
  faBars,
  faCircleCheck,
  faFileCircleCheck,
  faClipboardCheck,
  faListCheck,
  faList,
  faRectangleList,
  faOutdent,
  faSackDollar,
  faBuilding,
  faUsersRectangle,
  faImage,
  faUserGear,
  faSliders,
  faUsersViewfinder,
  faUserTie,
  faUserCheck,
  faUsersLine,
} from "@fortawesome/free-solid-svg-icons";

const iconHandler = () => {
  library.add(
    faGauge,
    faMoon,
    faRocket,
    faUsers,
    faPerson,
    faTableList,
    faGears,
    faBell,
    faUserGroup,
    faBuildingColumns,
    faWallet,
    faFileInvoice,
    faReceipt,
    faPlaneCircleCheck,
    faUsersBetweenLines,
    faUsersGear,
    faUserClock,
    faUserPen,
    faMoneyBillTrendUp,
    faFileCirclePlus,
    faClipboardList,
    faSheetPlastic,
    faMoneyBillWave,
    faTable,
    faPiggyBank,
    faBarsStaggered,
    faMoneyBillTransfer,
    faFileCircleCheck,
    faClipboardCheck,
    faListCheck,
    faList,
    faReceipt,
    faOutdent,
    faSackDollar,
    faBuilding,
    faUsersRectangle,
    faImage,
    faUserGear,
    faSliders,
    faUserTie,
    faUserGroup,
    faUserCheck,
    faListCheck,
    faUsersLine
  );
};

export { iconHandler };
